<template>
  <div>
    <b-card no-body class="card-statistics">
      <b-card-header>
        <b-card-title>{{ title}} </b-card-title> 
        <div class="d-none">
          <b-card-text class="font-small-2 mr-25 mb-0">
            {{ lastUpdated }} dakika önce güncellendi
          </b-card-text>
          <feather-icon
            size="18"
            icon="RefreshCcwIcon"
            class="cursor-pointer"
            @click="refreshData"
          />
        </div>
        <div class="w-full dropdown-style d-flex">
        <div class="mt-1 mr-2">
          <b v-if="rangeSelect!='all'">
            {{ formatDate(rangeDate[0]) }} - {{ formatDate(rangeDate[1]) }}
          </b>
        </div>

        <div class="d-flex align-items-end">
          <v-select
            :options="rangeOptions"
            v-model="rangeSelect"
            :reduce="val => val.value"
            class="w-auto fixed-width btn text-primary p-0 dropdown-toggle btn-outline-primary"
            placeholder="Tarih Aralığı"
            :clearable="false"
            @input="updateRangeCustom"
          />

          <div v-if="rangeSelect === 'custom'" class="d-flex align-items-center ml-1">
            <feather-icon icon="CalendarIcon" size="20" @click="openDatePicker" class="cursor-pointer" />
            <flat-pickr
              ref="flatPickrRef"
              v-model="rangePicker"
              :config="{ mode: 'range', dateFormat: 'Y-m-d' }"
              class="form-control flat-picker bg-transparent border-0 shadow-none hide"
              @change="updateDateRange"
            />
          </div>
        </div>
      </div>
      </b-card-header>
      <b-overlay :show="loadAnalysis" opacity="0.6" spinner-variant="primary">
        <b-card-body class="statistics-body" >
          <b-row class="justify-content-between globalIst" v-if="!warning">
            <b-col v-for="item in filteredStatisticsItems" :key="item.icon" cols="auto">
              <b-media no-body class="d-flex">
                <b-media-aside>
                  <b-avatar size="48" :variant="item.color">
                    <feather-icon size="24" :icon="item.icon" />
                  </b-avatar>
                </b-media-aside>
                <b-media-body class="my-auto text-center mt-1">
                  <h4 class="font-weight-bolder mb-0">{{ item.title }}</h4>
                  <b-card-text class="font-small-3 mb-0" v-html="item.subtitle"></b-card-text>
                </b-media-body>
              </b-media>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-danger">
            {{ warning }}
            </b-col>
          </b-row>
        </b-card-body>
      </b-overlay>
    </b-card>
    <div class="border-bottom" v-if="!vestingHide"></div>
    <b-card no-body class="card-statistics" v-if="!linkId && !vestingHide">
      <b-card-header>
        <b-card-title>Hakediş</b-card-title> 
      </b-card-header>
      <b-card-body class="statistics-body">
        <b-row v-if="!warningVesting">
          <b-col
            v-for="item in vestingItems"
            :key="item.icon"
            xl="4"
            sm="6"
            :class="item.customClass"
          >
            <b-media no-body>
              <b-media-aside class="mr-2">
                <b-avatar size="48" :variant="item.color">
                  <feather-icon size="24" :icon="item.icon" />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">{{ item.title }}</h4>
                <b-card-text class="font-small-3 mb-0">{{ item.subtitle }}</b-card-text>
              </b-media-body>
            </b-media>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col class="text-danger">
            {{ warningVesting }}
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody, BOverlay
} from 'bootstrap-vue'

export default {
  components: {
    BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,vSelect,flatPickr, BOverlay
  },
  props: {
    linkId: {
      type: [String,Number],
      default:(null) 
    },
    infId: {
      type: Number,
      default:(null) 
    },
    type: {
      type: Number,
      default:(null) 
    },
    platform_id: {
      type: Number,
      default:(null) 
    },
    groupId: {
      type: Number,
      default:(null) 
    },
    vestingHide: {
      type: Boolean,
      default:(false) 
    },
    title: {
      type: String,
      default: 'İstatistikler'
    }
  },
  data() {
    
    const today = new Date();
    const start = new Date(today);
    start.setDate(start.getDate() - 6); // Son 1 hafta (bugün dahil)
    return {
      statisticsItems: [
        { icon: 'Link2Icon', color: 'light-warning', title: null, subtitle: 'Paylaşım', customClass: '' },
        { icon: 'SendIcon', color: 'light-info', title: null, subtitle: 'Ziyaret', customClass: 'mb-2 mb-xl-0' },
        { icon: 'ShoppingCartIcon', color: 'light-danger', title: null, subtitle: 'Sepete Ekleme', customClass: 'mb-2 mb-sm-0' },
        { icon: 'TrendingUpIcon', color: 'light-primary', title: null, subtitle: 'Satış Adedi', customClass: 'mb-2 mb-xl-0' },
        { icon: 'DollarSignIcon', color: 'light-success', title: null, subtitle: 'Ciro', customClass: '' }
      ],
      vestingItems: [
        { icon: 'BarChart2Icon', color: 'light-danger', title: null, subtitle: 'Toplam', customClass: 'mb-2 mb-sm-0' },
        { icon: 'TrelloIcon', color: 'light-primary', title: null, subtitle: 'Hakedilecek', customClass: 'mb-2 mb-xl-0' },
        { icon: 'WindIcon', color: 'light-success', title: null, subtitle: 'Hakedilen', customClass: '' }
      ],
      lastUpdated: '0', // İlk değer
      lastUpdateTime: new Date(), // Güncelleme zamanı
      warning:null,
      warningVesting:null,
       rangeOptions: [
        { label: 'Son 1 Hafta', value: 'week' },
        { label: 'Son 2 Hafta', value: 'twoWeeks' },
        { label: 'Son 1 Ay', value: 'month' },
        { label: 'Tüm Zamanlar', value: 'all' },
        { label: 'Özel Seçim', value: 'custom' },
      ],
      rangeSelect: 'week',
      rangeDate: [start, today],
      rangePicker: `${this.formatDate(start)} to ${this.formatDate(today)}`,
      loadAnalysis:false
    }
  },
  methods: {
    
    updateRangeCustom() {
      const today = new Date();
      let start = new Date(today); // Bugünün bir kopyasını oluştur

      if (this.rangeSelect === 'week') {
        start.setDate(today.getDate() - 6);
      } else if (this.rangeSelect === 'twoWeeks') {
        start.setDate(today.getDate() - 13);
      } else if (this.rangeSelect === 'month') {
        start = new Date(today.getFullYear(), today.getMonth(), 1);
      } else if (this.rangeSelect === 'all') {
        start = null
      } else if (this.rangeSelect === 'custom') {
        setTimeout(() => {
          this.openDatePicker();
        }, 200);
      }
      if (this.rangeSelect !== 'custom') {
        this.rangeDate = [start, today];
        this.rangePicker = `${this.formatDate(start)} to ${this.formatDate(today)}`;
        this.getSummaryData();
      }
    },
    updateCustomRange(selectedDates) {
      if (selectedDates.length === 2) {
        const start = new Date(selectedDates[0]);
        const end = new Date(selectedDates[1]);
        this.rangeDate = [start, end];
        this.rangePicker = `${this.formatDate(start)} to ${this.formatDate(end)}`;
        this.getSummaryData();
      }
    },
    openDatePicker() {
      const flatpickrInstance = this.$refs.flatPickrRef.fp;
      flatpickrInstance.open();
    },
    async getSummaryData () {
      this.loadAnalysis = true;
      try {
        let params = {
          'source': this.$route.name
        }
        if(this.linkId){
          params['linkId'] = this.linkId
        }
        if(this.infId){
          params['infId'] = this.infId
        }
        if(this.type){
          params['type'] = this.type
          this.statisticsItems[0].subtitle="Bio";
        }
        if(this.platform_id){
          params['platform_id'] = this.platform_id
          this.statisticsItems[0].subtitle="Bio Linki";
        }
        if(this.groupId){
          params['groupId'] = this.groupId
          this.statisticsItems[0].subtitle="Paylaşım";
        }
        const [start, end] = this.rangeDate;

        params['start_date'] = this.formatDate(start);
        params['end_date'] = this.formatDate(end);

        const baseUrl = 'analysis/summaryData';
        const response = await this.$http.get(baseUrl,{params});
        if (response.data.error) {
          console.error('Error:', response.data.error);
        } else {
          const data = response.data.data;
          console.log("Summary Data:", data);
          if (response.data.success) {
              if (!data.global) {
                  this.warning = 'İstatistik verilerine erişim yetkiniz bulunmamaktadır.';
              }
              if (!data.vesting) {
                  this.warningVesting = 'Hakediş verilerine erişim yetkiniz bulunmamaktadır.';
              }
          }
          // statisticsItems dizisini güncelle
          this.statisticsItems[0].title = data.global.link;        // event Adedi
          this.statisticsItems[1].title = data.global.event;        // event Adedi
          this.statisticsItems[2].title = data.global.cart;         // Cart

          // Sipariş aded, iç link ve dış link adedi
          const orderTotal = `
            ${data.global.order.total} Sipariş / ${data.global.order.in_link+data.global.order.out_link} Ürün
          `;

          const link_type =`
          <div class="d-flex flex-column">
            <b class="text-success">${data.global.order.in_link} adet iç link</b> 
            <b class="text-danger">${data.global.order.out_link} adet dış link</b> 
          </div>
          `;

          this.statisticsItems[3].title = orderTotal;
          this.statisticsItems[3].subtitle = link_type;
          
          // Sipariş toplam tutarı, iç link ve dış link tutarları
          const priceTotal = `
            ${this.priceFormat(Math.ceil(data.global.price.total))} Ciro
          `;

          const subTitle =`
          <div class="d-flex flex-column">
            <b class="text-success">${this.priceFormat(Math.ceil(data.global.price.in_link))} iç link</b> 
            <b class="text-danger">${this.priceFormat(Math.ceil(data.global.price.out_link))} dış link</b> 
          </div>
          `;

          // this.statisticsItems[4].title'e ata
          this.statisticsItems[4].title = priceTotal;
          this.statisticsItems[4].subtitle = subTitle;
          
          this.vestingItems[0].title = this.priceFormat(Math.ceil(data.vesting.total)) || '0 TL';  // Toplam Kazanç
          this.vestingItems[1].title = this.priceFormat(Math.ceil(data.vesting.vestingFalse)) || '0 TL';  // Toplam Kazanç
          this.vestingItems[2].title = this.priceFormat(Math.ceil(data.vesting.vestingDone)) || '0 TL';  // Toplam Kazanç
          
          // Güncellenme süresini ve zamanı güncelle
          this.lastUpdated='0'
          this.updateLastUpdatedTime();  // this bağlamı korunur
          this.lastUpdateTime = new Date(); // Zamanı güncelle
        }

        this.loadAnalysis = false;

      } catch (error) {
        console.error('Veri alırken hata oluştu:', error);
      }
    },
    
    formatDate(date) {
      if (!(date instanceof Date)) date = new Date(date);
      
      const pad = (n) => n.toString().padStart(2, '0');

      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());

      // this.rangePicker.end varsa saat bilgileri de dahil et
      if (this.dateRangeCustom?.end) {
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } else {
        return `${year}-${month}-${day}`;
      }
    },
    updateLastUpdatedTime() {
      const now = new Date();
      const diff = Math.floor((now - this.lastUpdateTime) / 60000); // Dakikalar
      this.lastUpdated = diff;
    },
    refreshData() {
      this.getSummaryData(); // Verileri yeniden yükle
    }
  },
  computed: {
    filteredStatisticsItems() {
      return this.linkId!=null && this.linkId!=undefined
        ? this.statisticsItems.filter(item => item.subtitle !== 'Paylaşım')
        : this.statisticsItems;
        
    }
  },
  created() {
    this.getSummaryData(); // İlk yükleme
    // Interval ayarla
    this.updateInterval = setInterval(() => {
      this.updateLastUpdatedTime(); // Arrow function ile this bağlamı korunuyor
    }, 60000); // Her 1 dakikada bir çalışacak
  },
  beforeDestroy() {
    // Component yok edilirken interval'ı temizle
    clearInterval(this.updateInterval);
  }
}
</script>
<style>
@media screen and (max-width:1350px) {
  .globalIst > div >div {
      flex-direction: column !important;;
      justify-content: center;
      align-items: center;
  }


  .globalIst > div >div .media-aside {
      margin: 0;
      margin-bottom: 10px;
      align-self: initial !important;;
  }

  .globalIst > div >div h4 {
      font-size: 14px;
  }
}
</style>


